import { Flex, SegmentedControl } from '@cognite/cogs.js-v10';
import { Input, Switch } from '@cognite/cogs.js-v10';
import { useMetrics } from '@cognite/metrics';
import { LOCIZE_NAMESPACES } from '@infield/features/i18n';
import { useTranslation } from '@infield/features/i18n';
import {
  handleChangeInputValue,
  handleOnBeforeInput,
  noLetters,
} from '@infield/features/measurements/numeric/measurement-numeric-reading/utils';
import { METRICS_NAMESPACES } from '@infield/features/metrics';
import { useDeviceContext } from '@infield/providers/device-provider';
import { type FC, useState } from 'react';

export const InputKeyboardTester: FC = () => {
  const { t } = useTranslation(LOCIZE_NAMESPACES.user);
  const { keyboardConfig } = useDeviceContext();
  const [showInput, setShowInput] = useState(false);
  const [readingInput, setReadingInput] = useState<string | undefined | null>(
    null
  );
  const metrics = useMetrics(METRICS_NAMESPACES.keyboardSettings);
  return (
    <Flex direction="column" style={{ gap: '24px' }}>
      <Switch
        label={t('USER_PROFILE_KEYBOARD_SWITCH_LABEL', 'Test your keyboard')}
        onChange={(_, checked: boolean | undefined) => {
          metrics.track('keyboard_mode_tested_manually');
          setShowInput(checked ?? false);
        }}
      />
      {showInput && (
        <Input
          type={keyboardConfig.type}
          inputMode={keyboardConfig.inputMode}
          step={keyboardConfig.step}
          variant="outline"
          value={readingInput ?? ''}
          onChange={(e) =>
            handleChangeInputValue(e, setReadingInput, keyboardConfig.type)
          }
          onBeforeInput={handleOnBeforeInput}
          data-testid="keyboard-test-input"
          hideSpinButtons
          maxLength={64}
        />
      )}
    </Flex>
  );
};
